import { useEffect, useState } from "react";

import { updateBrandingSettings } from "../../services/settingsApi";

function BrandingSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        logo: "",
        favicon: "",
        splashImage: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                logo: settings.logo || "",
                favicon: settings.favicon || "",
                splashImage: settings.splashImage || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateBrandingSettings(formData);

            alert("Branding settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update branding settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Branding Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Logo URL</label>

                        <input
                            type="text"
                            name="logo"
                            value={formData.logo}
                            onChange={handleChange}
                            placeholder="https://..."
                        />

                    </div>

                    <div className="form-group">

                        <label>Favicon URL</label>

                        <input
                            type="text"
                            name="favicon"
                            value={formData.favicon}
                            onChange={handleChange}
                            placeholder="https://..."
                        />

                    </div>

                    <div className="form-group">

                        <label>Splash Screen Image URL</label>

                        <input
                            type="text"
                            name="splashImage"
                            value={formData.splashImage}
                            onChange={handleChange}
                            placeholder="https://..."
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Branding Settings
                </button>

            </div>

        </form>

    );

}

export default BrandingSettings;